import React from "react";
import CompanyDetails from "../../components/CompanyDetails";

const Company = () => {
  return (
    <div className="size-full p-6 xl:p-8 2xl:p-10">
      <CompanyDetails />
    </div>
  );
};

export default Company;
